import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUserEdit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user-edit, people, person, member"><path d="M11 20.25H4.75V19.5C4.75 15.4959 7.99594 12.25 12 12.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="7.75" r="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 20.25V17.5833L17.75 13.5833C18.4864 12.847 19.6803 12.847 20.4167 13.5833C21.153 14.3197 21.153 15.5136 20.4167 16.25L16.4167 20.25H13.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconUserEdit;
